// extracted by mini-css-extract-plugin
export default {"spinner":"SpinnerSVG_spinner__xsmYF","spin":"SpinnerSVG_spin__ydEAA"};